/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FufiPaymentType = {
    Unknown: 'Unknown',
    Normal: 'Normal',
    Unsolicited: 'Unsolicited',
    Unsolved: 'Unsolved'
} as const;
export type FufiPaymentType = typeof FufiPaymentType[keyof typeof FufiPaymentType];


export function instanceOfFufiPaymentType(value: any): boolean {
    for (const key in FufiPaymentType) {
        if (Object.prototype.hasOwnProperty.call(FufiPaymentType, key)) {
            if (FufiPaymentType[key as keyof typeof FufiPaymentType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FufiPaymentTypeFromJSON(json: any): FufiPaymentType {
    return FufiPaymentTypeFromJSONTyped(json, false);
}

export function FufiPaymentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiPaymentType {
    return json as FufiPaymentType;
}

export function FufiPaymentTypeToJSON(value?: FufiPaymentType | null): any {
    return value as any;
}

export function FufiPaymentTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FufiPaymentType {
    return value as FufiPaymentType;
}

